import { render, staticRenderFns } from "./pkl_jenis_kelahiran.vue?vue&type=template&id=23e8e4aa&"
import script from "./pkl_jenis_kelahiran.vue?vue&type=script&lang=js&"
export * from "./pkl_jenis_kelahiran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPageContainer,QCard,QCardSection,QBtn,QMarkupTable,QPagination,QDialog,QInput,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPageContainer,QCard,QCardSection,QBtn,QMarkupTable,QPagination,QDialog,QInput,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
